import { ENVIRONMENT_SHARED } from "./environment.shared";

export const environment = {
    production: true,

    api_url: 'https://api.verygames.com',

    build_version: 'Fri, 11 Oct 2024 20:13:22 UTC',

    stripeApiKey: 'pk_test_51JKNRLKKDcj9UjYuWefMe2nz04iKwzmMeRI8XriWhHW1fxQUklfBmWoHjbO3WK1QCmbb2Hs8GhVnIq5QnfZ6hlm100qSfI6GKK',
    stripeAccount: 'acct_1JPpq2JgZcHYexwM',

    api_socketio_path: '/socket.io/',
    api_socketio_endpoint: 'https://ws.verylys.net:4001/verygames', //Company name

    sentry_environment: "production",
    sentry_release: "master",
    sentry_enabled: true,

    default_currency: "6103c9812d76c68c2d4996b2",
    default_country: "6579debdcadf0b26a81e3a6c",

    panel_url: "https://panel.verygames.com",

    googleTrackingId: "G-94WLQWMCW4",

    ...ENVIRONMENT_SHARED,
};
